import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  gridItem: {
    marginTop: '-12px',
  },
  subHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginRight: theme.spacing(1.125),
  },
  infoIcon: {
    color: theme.palette.icon.main,
    marginTop: theme.spacing(0.75),
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  textField: {
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      display: 'none',
    },
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
      color: `${theme.palette.error.main} !important`,
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  companyDetailSubHead: {
    marginBottom: theme.spacing(2),
  },
  dateField: {
    '& .MuiInputLabel-root': {
      marginTop: theme.spacing(-0.5),
    },
  },
  textAlign: {
    textAlign: 'left',
  },
  selectField: {
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  inputLabel: {
    '&.MuiFormLabel-root': {
      fontSize: '12px',
      color: theme.palette.primary.light,
      fontWeight: 600,
      display: 'flex',
    },
    transform: 'translateY(20px) scale(1)',
  },
  menuRoot: {
    '&.MuiMenuItem-root': {
      fontSize: '13px',
      color: theme.palette.headerTitle.main,
    },
    '&.MuiListItem-gutters': {
      padding: theme.spacing(1.5),
    },
    '&.MuiListItem-root.Mui-selected': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
    '&.MuiListItem-button:hover': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
  },
  icon: {
    '&.MuiSelect-icon': {
      color: theme.palette.text.tertiary,
    },
  },
  selectFormWidth: {
    width: '100%',
    minWidth: '135px',
  },
}))
